export function log(string) {
    console.log(string);
}
